const ACTION_TYPES = {
    SET_INITIALIZATION: 'SET_INITIALIZATION'
};

const initialState = {
    isInitialized: false
};

const reducer = function (state = initialState, { type, payload }) {
    switch (type) {
        case ACTION_TYPES.SET_INITIALIZATION:
            return Object.assign({}, state, {
                isInitialized: payload
            });

        default:
            return state;
    }
};

reducer.ACTION_TYPES = ACTION_TYPES;

module.exports = reducer;
